import React from "react";
import { CCol, CFormGroup, CLabel, CRow, CTextarea } from "@coreui/react";
import { useReceiptFormContext } from "../context/ReceiptFormContext";
import { FieldErrors } from "../../form/FieldErrors";
import { getFieldErrors } from "../../../models/errors";
import ReceiptFormSection from "./ReceiptFormSection";
import { ReceiptFormItems } from "./ReceiptFormItems";

const ReceiptFormDetailSection: React.FC = () => {
  const { receiptRef, errors, onDescriptionChange, readonly } = useReceiptFormContext();

  return (
    <ReceiptFormSection id="receipt-detail" icon="fa-file-text-o" label="Detalle">
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <CLabel htmlFor="receipt-description" className="mb-0" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>
              Descripción:
            </CLabel>
          </CCol>
          <CCol md={10}>
            <CTextarea
              id="receipt-description"
              disabled={readonly}
              placeholder="Descripción"
              defaultValue={receiptRef.current?.description}
              onChange={onDescriptionChange}
              style={{ resize: "vertical", minHeight: "70px" }}
            />
            <FieldErrors errors={getFieldErrors("description", errors) as string[]} />
          </CCol>
        </CRow>
      </CFormGroup>
      <ReceiptFormItems />
    </ReceiptFormSection>
  );
};

export default ReceiptFormDetailSection;
